import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import CONTROL_BUTTON from './control-button.palette-schema.yaml';

registerTileSchema(CONTROL_BUTTON);

export function generateControlButton(TILE) {
    return {
        button: {
            ...resolveBackground(TILE.CONTROL_BUTTON_BG),
            width: 32,
            height: 32,
            alignSelf: 'center',
            borderRadius:
                TILE.CONTROL_BUTTON_RADIUS < 0 ? `${-TILE.CONTROL_BUTTON_RADIUS}%` : TILE.CONTROL_BUTTON_RADIUS,
        },
        icon: icon(TILE.CONTROL_BUTTON_ICON_COLOR),
    };
}

export function generateScrollButtonPane(TILE) {
    const SCROLL_BUTTON = generateControlButton(TILE);

    return {
        rightScrollButton: {
            style: {
                base: {
                    ...SCROLL_BUTTON.button,
                },
            },
        },
        leftScrollButton: {
            style: {
                base: {
                    ...SCROLL_BUTTON.button,
                },
            },
        },
        rightScrollButtonIcon: SCROLL_BUTTON.icon,
        leftScrollButtonIcon: SCROLL_BUTTON.icon,
    };
}
